import { HudActions, HudEmitter } from '../../../../Managers/Hud/HudEmitter';
import { ICollectablesData } from '../../../../State/reducers/player';
import { Collection } from '../../../../Tiles/TileSet';
import { RadioGroup, RadioGroupEvents } from '../../../Shared/RadioGroup/RadioGroup';
import { ScrollView } from '../../../Shared/ScrollView/ScrollView';
import { CollectableRadioGroupItem } from './CollectableRadioGroupItem';

export class CollectablesRadioGroup extends RadioGroup {
    private scrollView: ScrollView;

    constructor(
        bgTab: PIXI.mesh.NineSlicePlane,
        collectablesProgress: ICollectablesData,
        selectedCollection: Collection
    ) {
        super();
        const { width, height } = bgTab;
        this.scrollView = new ScrollView(width, height, this, true);
        this.createList(collectablesProgress);
        this.selectedIndex = Object.values(Collection).indexOf(selectedCollection);

        this.on(RadioGroupEvents.SELECTION_CHANGED, (selection: CollectableRadioGroupItem) => {
            HudEmitter.instance.emit(HudActions.SET_COLLECTION, selection.collection);
        });
    }

    private createList(collectablesProgress: ICollectablesData) {
        Object.values(Collection).forEach((collection, index) => {
            const button = new CollectableRadioGroupItem(
                collection,
                collectablesProgress[collection] || 0
            );
            button.x = this.scrollView.scrollView.screenWidth / 2;
            const spacing = 10;
            button.y = button.height * 0.04 + button.height / 2 + index * (button.height + spacing);
            this.addItem(button);
            this.scrollView.addItem(button);
        });
    }
}
